import { defineMessages } from 'react-intl';

export default defineMessages({
    dots: {
        id: 'ml.quoteandbind.common.employeraffilitationsaccordionbody.dots',
        defaultMessage: '...'
    },
    paypointNumber: {
        id: 'ml.quoteandbind.common.employeraffilitationsaccordionbody.paypointNumber',
        defaultMessage: 'Paypoint: '
    },
    payPeriod: {
        id: 'ml.quoteandbind.common.employeraffilitationsaccordionbody.payPeriod',
        defaultMessage: 'Pay Period: '
    },
    details: {
        id: 'ml.quoteandbind.common.employeraffilitationsaccordionbody.details',
        defaultMessage: 'Details'
    },
    eligibilityComments: {
        id: 'ml.quoteandbind.common.employeraffilitationsaccordionbody.eligibilityComments',
        defaultMessage: 'Eligibility Comments: '
    }
});
